import { FC } from 'react'
import { Row, Col, Text, Image } from '@/client/components'
import * as S from './styles'
import { TutorialListProps } from '../types'

export const TutorialList: FC<TutorialListProps> = ({ tutorials }) => (
  <Row>
    <Col xs={12}>
      <S.TutorialList>
        {tutorials.map(({ tutorial_link, target, tutorial_title, img: { url, width, height, alt } }) => (
          <S.Card key={tutorial_title} href={tutorial_link} target={target}>
            <S.CardImage>
              <Image
                src={url}
                alt={alt}
                width={width}
                height={height}
                style={{ display: 'block', width: '100%', height: 'auto' }}
              />
            </S.CardImage>

            <S.CardInfos>
              <S.Illustrator>
                <Image src='/img/illustrator.svg' alt='Illustrator' width='40' height='40' />
              </S.Illustrator>
              <Text family='heading' weight='bold' margin='0'>
                {tutorial_title}
              </Text>
            </S.CardInfos>
          </S.Card>
        ))}
      </S.TutorialList>
    </Col>
  </Row>
)
